module.exports = __webpack_public_path__ + "img/handreinigung.ddd5123.png";